export const refundStates = [
  { code: 'pending', name: 'Awaiting invoice', tone: 'amber' },
  { code: 'reported', name: 'Awaiting payment', tone: 'blue' },
  { code: 'verified', name: 'Completed', tone: 'green' },
  { code: 'not_required', name: 'No refund required', tone: 'neutral' }
]
export function refundState(code) { return refundStates.find(item => item.code === code) || { name: code, tone: 'neutral' } }
export function money(value, currency = 'USD') { return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(Number(value || 0)) }
export function dateLabel(value) { return value ? new Intl.DateTimeFormat('en-GB', { dateStyle: 'medium' }).format(new Date(value)) : '—' }
export function errorMessage(error) {
  if (error.response && [403, 404].includes(error.response.status)) return 'This record is not available to your account.'
  return (error.response && error.response.data && error.response.data.details) || 'Unable to complete this request. Please try again.'
}
